<template>
  <div class="inner-container">
      <div class="content-container4">
        <div class="progress-container4 mb-8">
          <div class="progress-bar4"></div>
        </div>


        <!-- Hier wird die Klasse aktualisiert -->
        <div>
          <div class="display-1 mb-8 text-center">Welche Pflegebox möchten Sie haben?</div>
          <v-row class="align-center justify-center">
            <v-col v-for="box in preDesignedBoxes" :key="box.title" cols="12" md="4">
              <v-card
                  :color="selectedBox && selectedBox.title === box.title ? 'primary' : 'white'"
                  @click="handleBoxClick(box)"
                  class="hoverable-card mb-4"
              >
                <v-img :src="box.image"
                       contain
                       height="200px"
                       width="300px"></v-img>

                <div class="label-container text-center white--text display-1">
                  {{ box.title }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>





          <router-link
            to="/boxauswahl"
            class="text-center d-block mt-10 custom-link secondary--text"
        >
          Pflegehilfsmittelpardies Pflegebox individuell Zusammenstellen
        </router-link>

      </div>
  </div>
</template>



<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PBStepper from "@/components/PB-Stepper.vue";

export default {
  components: { PBStepper },
  data: () => ({
    selectedBox: null
  }),
  computed: {
    ...mapGetters([
      'totalValue',
    ]),
    ...mapState({
      'preDesignedBoxes': state => state.system.preDesignedBoxes
    }),
  },
  methods: {
    ...mapActions([
      'selectBoxMethod',
      'goToNextStep'
    ]),
    selectBoxMethod(box) {
      this.$store.commit('selectBox', box.id);
    },
    handleBoxClick(box) {
      this.selectBoxMethod(box);  // Speichern Sie die ausgewählte Box im Store
      this.navigateToBox(box);    // Navigieren Sie zur entsprechenden Route
    },
    navigateToBox(box) {
      this.$router.push('/bettschutz');
    },
  }
};
</script>

<style>

.inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-container4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  /* Dies verteilt den Raum zwischen den Hauptblöcken */
  height: 80vh;
  padding: 0 15px;
}

.progress-container4 {
  display: flex;  /* Hinzugefügt, um Flex-Container zu aktivieren */
  width: 40%;
  height: 20px;
  align-items: center;  /* Dies wird den Fortschrittsbalken vertikal zentrieren */
  background-color: #f0f0f0; /* Hintergrundfarbe des Fortschrittsbalkens */
}

.progress-bar4 {
  width: 80%; /* 2 von 5 Schritten -> 40% */
  height: 100%;
  background-color: var(--v-primary-base); /* Primärfarbe des Fortschrittsbalkens */
}

.label-container {
  background-image: linear-gradient(315deg, #f9ad18, #f98918 80%);
  padding: 10px 0;
  font-size: 1.5em;
  width: 100%;
}



/* Hervorhebungsstil für die Karte beim Darüberfahren */
.hoverable-card {
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hoverable-card:hover {
  transform: scale(1.05);  /* Karte vergrößern */
}

.custom-link {
  text-decoration: none;
  font-size: 18px;  /* Sie können die Größe nach Bedarf anpassen */
  transition: color 0.3s ease;  /* Für eine sanfte Farbänderung beim Überfahren */
  margin-top: 0px;
}

.custom-link:hover {
  color: #f98918;  /* Eine Farbe beim Überfahren. Sie können dies an Ihre Vorlieben anpassen */
}
</style>
